import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { BillingService } from 'src/app/services/billing/billing.service';

@Component({
  selector: 'app-billing-banner',
  templateUrl: './billing-banner.component.html',
  styleUrls: ['./billing-banner.component.scss'],
})
export class BillingBannerComponent implements OnInit {
  isPlanExpired: boolean = false;
  constructor(public billingService: BillingService) {}

  async ngOnInit() {
    try {
      await this.billingService.getBillingDetails();
      if (this.billingService.growthPlan) {
        this.isPlanExpired = moment(
          this.billingService.growthPlan?.trialEnd,
        ).isBefore(moment());
      }
    } catch (error) {
      console.log('Billing meta data error response', error);
    }
  }
}
